'use client'
import { Button } from '@/shared/components/Button'
import { cn } from '@/shared/utils/cn'
import { useEffect, useRef, useState } from 'react'
import { RxCaretDown } from 'react-icons/rx'
import { AnimatePresence, motion } from 'framer-motion'

export const NavMenu = (props: {
	label: string
	children: React.ReactNode
	className?: string
}) => {
	const [isOpen, setIsOpen] = useState(false)
	const menuRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
				setIsOpen(false)
			}
		}

		document.addEventListener('mousedown', handleClickOutside)
		return () => document.removeEventListener('mousedown', handleClickOutside)
	}, [])

	return (
		<div className={cn('relative', props.className)} ref={menuRef}>
			<Button
				variant="ghost"
				onClick={() => setIsOpen(!isOpen)}
				aria-expanded={isOpen}
			>
				{props.label}
				<RxCaretDown
					className={cn('size-6 transition-transform', {
						'rotate-180': isOpen
					})}
				/>
			</Button>

			<AnimatePresence>
				{isOpen && (
					<motion.div
						initial={{ opacity: 0, y: -10 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: -10 }}
						transition={{ duration: 0.2 }}
						className="absolute left-0 mt-2 rounded-md bg-gray-900 border border-gray-800 shadow-lg"
					>
						{props.children}
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	)
}
